/* eslint-disable */
import axios from 'axios'

export const NETWORK_ENV = process.env.REACT_APP_NETWORK_ENV || 'testnet'
export const gitVersion = process.env.REACT_APP_GIT_SHA || ''
export const cdnUrl = process.env.PUBLIC_URL || ''
window.__network__ = process.env.REACT_APP_NETWORK_ENV
window.__commit__ = gitVersion
window.__cdn_url__ = cdnUrl

const NET_WORK_MAPPING = {
  qa: ['dex-api.fdgahl.cn'],
  testnet: [
    'testnet-dex-asiapacific.binance.org',
    'testnet-dex-atlantic.binance.org',
    'testnet-dex-cn.swfjd.com',
  ],
  mainnet: [
    'dex-asiapacific.binance.org',
    'dex-european.binance.org',
    'dex-atlantic.binance.org',
    'dex-cn.yshyqxx.com',
  ],
}

const LANG_URL_MAPPING = {
  qa: 'https://i18n.fdgahl.cn',
  testnet: 'https://i18n.bnbstatic.com',
  mainnet: 'https://i18n.bnbstatic.com',
}

export const FINGER_PRINT_URL_MAPPING = {
  qa: 'https://dexqa-ud.fdgahl.cn',
  testnet: 'https://testnet-ud.binance.org',
  mainnet: 'https://ud.binance.org',
}

const LANG_URL = LANG_URL_MAPPING[NETWORK_ENV]

const WALLETCONNECTURL = 'https://wallet-bridge.binance.org'

export const NETWORKS = NET_WORK_MAPPING[NETWORK_ENV]

export const savedNetwork = window.sessionStorage.getItem('network')

const LIMIT = 1000

export const EXPLORER_URL = process.env.REACT_APP_EXPLORER

class HttpRequest {
  static instance

  constructor() {
    if (!HttpRequest.instance) {
      const baseUri = savedNetwork || NETWORKS[0]
      this.baseUri = `https://${baseUri}`
      this.wssUri = `wss://${baseUri}/api/`
      this.axiosClient = axios.create({
        baseURL: this.baseUri,
      })
      HttpRequest.instance = this
    }

    return HttpRequest.instance
  }

  getHttpBaseUri() {
    return this.baseUri
  }

  getWSSBaseUri() {
    return this.wssUri
  }

  setBaseUri(baseUri) {
    this.baseUri = `https://${baseUri}`
    this.wssUri = `wss://${baseUri}/api/`
  }

  getBalances(address) {
    return this.request('get', `/api/v1/balances/${address}`)
  }

  getAccount(address) {
    return this.request('get', `/api/v1/account/${address}`)
  }

  getNodeInfo() {
    return this.request('get', '/api/v1/node-info')
  }

  getPairs() {
    return this.request('get', '/api/v1/markets', { limit: LIMIT })
  }

  getFees() {
    return this.request('get', '/api/v1/fees')
  }

  getTokens() {
    return this.request('get', '/api/v1/tokens', { limit: LIMIT })
  }

  getDepth(params) {
    return this.request('get', '/api/v1/depth', params)
  }

  getOpenOrdersQS(params) {
    return this.request('get', '/api/v1/orders/open', params)
  }

  getOrderHistoryQS(params) {
    return this.request('get', '/api/v1/orders/closed', params)
  }

  getOrderTradeHistoryQS(params) {
    return this.request('get', '/api/v1/trades', params)
  }

  getFiatCurrency() {
    return this.request('get', '/api/v1/fiat-currency', null)
  }

  getCryptoCurrency() {
    return this.request('get', '/api/v1/crypto-currency', null)
  }

  get24HrTicker(params) {
    return this.request('get', '/api/v1/ticker/24hr', params)
  }

  getTradesByHeight(params) {
    return this.request('get', '/api/query/trades-by-height', params)
  }

  getPeers() {
    return this.request('get', 'api/v1/peers')
  }

  getTradesByBlock(params) {
    return this.request('get', 'api/v1/block-trades', params)
  }

  ipValidate() {
    return this.request('get', 'api/ip-validate')
  }

  getTransactions(params) {
    return this.request('get', '/api/v1/transactions', params)
  }

  getBlockExchangeFees(params) {
    return this.request('get', '/api/v1/block-exchange-fee', params)
  }

  getI18nData(lang) {
    return this.request('get', `/i18n/api/v1/out/web-wallet-ui/${lang}`, {}, LANG_URL, 1000)
  }

  checkTopic(topic) {
    return this.request('get', '/checkTopic', { topic }, WALLETCONNECTURL, 3000)
  }

  getKline(params) {
    return this.request('get', `/api/v1/klines`, params)
  }

  ping(baseUri) {
    return this.request('get', '/api/v1/ping', null, baseUri)
  }

  collectMetrics(params) {
    const options = {
      method: 'post',
      data: JSON.stringify(params),
      url: '/api/perf/metrics',
      baseURL: this.baseUri,
      headers: {
        'content-type': 'application/json',
      },
    }

    return this.axiosClient
      .request(options)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
      })
  }

  sendFingerPrint(data) {
    const options = {
      method: 'post',
      data: data.toString('hex'),
      url: '/api/v1/uo',
      baseURL: FINGER_PRINT_URL_MAPPING[NETWORK_ENV],
      timeout: 3000,
      headers: {
        'content-type': 'text/plain',
      },
    }

    return this.axiosClient
      .request(options)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
      })
  }

  request(method, path, params, baseUri, timeout = 30000) {
    const options = {
      timeout,
      method: method.toLowerCase(),
    }

    options.baseURL = baseUri || this.baseUri

    if (options.method === 'get') {
      options.url = formatUrlQuery(path, params)
    }

    if (options.method === 'post') {
      options.data = JSON.stringify(params)
    }

    return this.axiosClient
      .request(options)
      .then(response => {
        return response.data
      })
      .catch(error => {
        console.error(`[API Failed] ${error.message || ''}`, error, options)
        throw error
      })
  }
}

function formatUrlQuery(url, data) {
  const arr = []
  for (const k in data) {
    arr.push(`${k}=${data[k]}`)
  }
  return `${url}?${arr.join('&')}`
}

export default new HttpRequest()
